export const tableHeader = ['Name', 'Send SMS', 'Send Email'];